import * as crypto from 'crypto-browserify'
import _, { get, isEmpty } from 'lodash'
import { breadcrumbArray } from 'helpers/page.breadcrumb'
import { getCookie, removeCookie } from './manageCookies'
import * as pageURL from './page.url'
import moment from 'moment'
import { Buffer } from 'buffer';
import { CUSTOM_MENU_SPLICE_START_POSITION, IDENTITY_DELEGATION_FLAG, LOCAL_STORAGE_KEYS, MENU_TITLES, PRINT_RENEWAL_INVOICE_MENU, PRINT_RENEWAL_INVOICE_URL, USER_INFO, cookieKeysEnum, membershipTypeJSON, nameFormatTypeEnum } from 'models/common.models'

export const Number_Regex = /^[0-9]*$/
// eslint-disable-next-line no-useless-escape
export const Email_Regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
export const PhoneNumber_Regex = /^[0-9 +\-()]*$/

export const Static_Pages = [
	process.env.REACT_APP_MEETING_BASE_URL,
	`${process.env.REACT_APP_MEETING_BASE_URL}/event`,
	`${process.env.REACT_APP_MEETING_BASE_URL}/symposia-proposal`,
	`${process.env.REACT_APP_MEETING_BASE_URL}/symposia-workshop`,
	`${process.env.REACT_APP_MEETING_BASE_URL}/search-keyword`,
];

const securityKey = 'aes-256-cbc'

// Function to allow only positive numeric characters
export const validateOnlyPositiveNumericInput = (val) => {
	return Number_Regex.test(val)
}

export const encrypt = (text) => {
	try {
		if (text) {
			let iv = crypto.randomBytes(Number(process.env.REACT_APP_STORAGE_IV_LENGTH))
			let cipher = crypto.createCipheriv(securityKey, Buffer.from(process.env.REACT_APP_STORAGE_VALUE), iv)
			let encrypted = cipher.update(text)
			encrypted = Buffer.concat([encrypted, cipher.final()])
			return iv.toString('hex') + ':' + encrypted.toString('hex')
		}
		return text
	} catch (e) {
		console.log('Exception in Encryption', e)
	}
}

export const decrypt = (text) => {
	try {
		if (text) {
			let textParts = text.split(':')
			if (textParts && textParts.length > 0) {
				let iv = Buffer.from(textParts.shift(), 'hex')
				let encryptedText = Buffer.from(textParts.join(':'), 'hex')
				let decipher = crypto.createDecipheriv(securityKey, Buffer.from(process.env.REACT_APP_STORAGE_VALUE), iv)
				let decrypted = decipher.update(encryptedText)
				decrypted = Buffer.concat([decrypted, decipher.final()])
				return decrypted.toString()
			}
		}
		return text
	} catch (e) {
		console.log('Exception in Decryption', e)
	}
}


export const cacheManager = {
	getItem: (key, isDecrypt = true) => {
		if (isDecrypt) {
			return decrypt(window.localStorage.getItem(key))
		}
		return window.localStorage.getItem(key)

	},
	setItem: (key, value) => {
		let string = _.isString(value) ? encrypt(value) : encrypt(JSON.stringify(value))
		window.localStorage.setItem(key, string)
	},
	removeItem: (key) => {
		window.localStorage.removeItem(key)
	},
	clearSession: () => {
		window.localStorage.clear()
		window.sessionStorage.clear()
	}
}

export const hasOpenAuthToken = () => {
	if (!_.isEmpty(getCookie('open-auth-token'))) {
		return getCookie('open-auth-token')
	}
	return false
}

export const getOpenAuthToken = () => {
	return getCookie('open-auth-token')
}

export const removedLastChar = (pageUrl) => pageUrl && pageUrl.endsWith('/') ? pageUrl.slice(0, -1) : pageUrl

export const getBreadcrum = (pageUrl = removedLastChar(window.location.pathname)) =>
	breadcrumbArray.find(urls => (urls.url === pageUrl || urls.url.toLowerCase() === pageUrl.toLowerCase())) &&
	breadcrumbArray.find(urls => (urls.url === pageUrl || urls.url.toLowerCase() === pageUrl.toLowerCase())).content


export const getHeader = (pageUrl = removedLastChar(window.location.pathname)) =>
	breadcrumbArray.find(urls => (urls.url === pageUrl || urls.url.toLowerCase() === pageUrl.toLowerCase())) &&
	breadcrumbArray.find(urls => (urls.url === pageUrl || urls.url.toLowerCase() === pageUrl.toLowerCase())).header

export const formatCommitteList = (committeeList) => {
	let transformed = []
	transformed = committeeList && committeeList.length > 0 && committeeList.map(({ Designation, Title }) => ({ label: Designation + ' - ' + Title, title: Title, designation: Designation }))
	return transformed
}

export const formatMainCommitteList = (committeeList) => {
	let transformed = []
	transformed = committeeList && committeeList.length > 0 && committeeList.map(({ CommitteeId, CommitteeDesignation, Title }) => ({ key: CommitteeId, value: CommitteeId, text: (CommitteeDesignation + ' - ' + Title) }))
	return transformed
}

export const formatSubCommitteList = (subCommitteeList) => {
	let transformed = []
	transformed = subCommitteeList && subCommitteeList.length > 0 && subCommitteeList.map(({ SubCommitteeId, CommitteeDesignation, Title }) => ({ key: SubCommitteeId, value: SubCommitteeId, text: (CommitteeDesignation + ' - ' + Title) }))
	return transformed
}

export const formatSubSectionCommitteList = (subCommitteeList) => {
	let transformed = []
	transformed = subCommitteeList && subCommitteeList.length > 0 && subCommitteeList.map(({ CommitteeId, CommitteeName }) => ({ key: CommitteeId, value: CommitteeId, text: CommitteeName }))
	return transformed
}

export const formatJournalList = (journalList) => {
	let transformed = []
	transformed = journalList && journalList.length > 0 && journalList.map(({ Code, Title }) => ({ key: Code, value: Code, text: Title }))
	return transformed
}

export const formatEventList = (eventList) => {
	let transformed = []
	transformed = eventList && eventList.length > 0 && eventList.map(({ EventId, EventName }) => ({ key: EventId, value: EventId, text: EventName }))
	return transformed
}

export const formatCountryList = (countryList) => {
	let transformed = []
	transformed = countryList && countryList.length > 0 && countryList.map(({ CountryCode, CountryName }) => ({ key: CountryCode, value: CountryCode, text: CountryName }))
	return transformed
}

export const formatStateList = (stateList) => {
	let transformed = []
	transformed = stateList && stateList.length > 0 && stateList.map(({ StateCode, StateName }) => ({ key: StateCode, value: StateCode, text: StateName }))
	return transformed
}

export const getMessage = (messageList, message) => {
	return _.get(messageList, message)
}

export const getAllPageURLs = pageURL

export const redirectToPage = (props, url) => {
	props.history.push(url)
}

export const encodeText = (text) => {
	return window.btoa(text)
}

export const decodeText = (text) => {
	if (text && text.length > 0) {
		return window.atob(text)
	}

	return ''
}

export const logout = (props) => {
	cacheManager.clearSession()
	props.history.push(pageURL.MeetingPageUrl)
}

export const login = () => {
	cacheManager.clearSession()
}

export const getFormattedDate = (date, format = 'MM/DD/YYYY') => {
	return moment(date).format(format)
}

export const deepCopy = (obj) => {
	return JSON.parse(JSON.stringify(obj))
}

export const getQueryString = (query) => {
	if (query) {
		let queryStringKeys = Object.keys(query)
		let queryString = []

		for (let val of queryStringKeys) {
			if (query[val] && query[val] !== undefined) {
				queryString.push(`${val}=${query[val]}`)
			}
		}

		return queryString.join('&')
	}
}

export const getTimeArray = (desiredStartTime, desiredEndTime, interval, period = 'hours') => {
	// start time and end time
	let startTime = moment(desiredStartTime, 'HH:mm:ss a')
	let endTime = moment(desiredEndTime, 'HH:mm:ss a')
	const periodsInADay = moment.duration(endTime.diff(startTime)).as(period)
	const timeLabels = []
	const startTimeMoment = moment(desiredStartTime, 'hh:mm')
	for (let i = 0; i <= periodsInADay; i += interval) {
		startTimeMoment.add(i === 0 ? 0 : interval, period)
		timeLabels.push(startTimeMoment.format('hh:mm A'))
	}
	return timeLabels
}

export const formatTimeList = (data) => {
	let result = []
	data && data.length > 0 && data.map(label => result.push({ key: label, value: label, text: label }))
	return result
}

export const getStandardTime = (desiredTime) => moment(desiredTime, 'h:mm A').add('30', 'minutes').format('HH:mm')

export const downloadFile = (docPath) => {
	const link = document.createElement('a')
	link.download = docPath || ''
	link.target = '_blank'
	// Construct the URI
	link.href = docPath
	document.body.appendChild(link)
	link.click()
}

export const getDaysBetweenDates = (startDate, endDate) => {
	let sDate = moment(startDate).format('YYYY-MM-DD')
	let eDate = moment(endDate).format('YYYY-MM-DD')
	return Math.round(Math.abs((new Date(eDate) - new Date(sDate)) / (24 * 3600 * 1000)))
}

export const getCurrentDate = () => new Date()

export const getDateWithFormat = (format = 'YYYY-MM-DD') => moment().format(format)

export const getMaxEndDate = (sDate, addDays) => {
	sDate = sDate ? sDate : new Date()
	let date = new Date(sDate)
	// add a day
	date.setDate(date.getDate() + addDays)
	return date
}

export const convertToBoolean = (value) => value && (value == '1')

export const getFilteredEventList = (events) => {
	let eventList = []

	if (events.length > 0) {
		for (let event of events) {
			let eventMeetings = event['meetings']
			let eventSymposia = event['symposias']
			// eslint-disable-next-line no-unused-vars
			const { meetings, symposias, ...newEventObject } = event
			if (eventMeetings && eventMeetings.length > 0) {
				for (let eventMeeting of eventMeetings) {
					eventMeeting.Event = newEventObject
					eventList.push(eventMeeting)
				}
			}

			if (eventSymposia && eventSymposia.length > 0) {
				for (let eventSymposium of eventSymposia) {
					eventSymposium.Event = newEventObject
					eventList.push(eventSymposium)
				}
			}
		}

		eventList = eventList.filter(event => ((new Date(event.MeetingSymposiaStartDate) - new Date() > 0) || (new Date(event.MeetingSymposiaEndDate) - new Date() > 0)))
		return eventList
	}
	return eventList

}

// TODO : Get User Agent (Identify request coming from browser.)
export const getUserAgent = () => {
	const test = (regexp) => regexp.test(window.navigator.userAgent)
	switch (true) {
		case test(/edg/i): return { name: 'Edge' }
		case test(/trident/i): return { name: 'IE' }
		case test(/firefox|fxios/i): return { name: 'Firefox' }
		case test(/opr\//i): return { name: 'Opera' }
		case test(/ucbrowser/i): return { name: 'UC' }
		case test(/samsungbrowser/i): return { name: 'Samsung' }
		case test(/chrome|chromium|crios/i): return { name: 'Chrome' }
		case test(/safari/i): return { name: 'Safari' }
		default: return { name: 'Other' }
	}
}

// Common Handler to scroll on error on form field.
export const scrollToErrorOnFormHandler = () => {
	const fields = 'input, select, textarea, .sidebar-selection-input' // Increase Fields as per requirement.
	const currentFormSelector = document.querySelectorAll('form')
	// Wait for is-Invalid class attached into the fields.
	setTimeout(() => {
		// Get all form into single screen.
		for (let index = 0; index < currentFormSelector.length; index++) {
			if (currentFormSelector[index]) {
				const fieldsElements = currentFormSelector[index].querySelectorAll(fields)
				// Get all fields from Form references.
				for (let i = 0; i < fieldsElements.length; i++) {
					if ((fieldsElements[i].classList && fieldsElements[i].classList.value.indexOf('is-invalid') > -1)
						|| (fieldsElements[i].offsetParent && fieldsElements[i].offsetParent.classList && fieldsElements[i].offsetParent.classList.value.indexOf('is-invalid') > -1)
					) {
						fieldsElements[i].scrollIntoView({ behavior: 'smooth', block: 'center' })
						return false
					}
				}
			}
		}
	}, 100)
}

export const generateUUID = (log = false) => {
	if (log) {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
			let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
			return v.toString(16)
		})
	}
}

export const getCalendarMinDate = () => (new Date(new Date().getFullYear() - 1, 0, 1))

export const getExcludedDate = (value, remainsDate = []) => {
	value = value ? value : new Date()
	let exclDates = []
	let CMonth = new Date(value).getMonth()
	let CYear = new Date(value).getFullYear()
	let DCount = new Date(CYear, CMonth, 0).getDate()
	for (let i = 1; i <= DCount; i++) {
		if (remainsDate && remainsDate.length > 0 && !remainsDate.contains(new Date(CYear, CMonth - 1, i)))
			exclDates.push(new Date(CYear, CMonth - 1, i))
		else if (remainsDate && remainsDate.length > 0 && !remainsDate.contains(new Date(CYear, CMonth + 1, i)))
			exclDates.push(new Date(CYear, CMonth + 1, i))
		else if (!remainsDate || remainsDate.length === 0) {
			exclDates.push(new Date(CYear, CMonth - 1, i))
			exclDates.push(new Date(CYear, CMonth + 1, i))
		}
	}
	return exclDates
}

export const getNumberArray = (startNumber, endNumber, interval, places = 1) => {
	let result = [];
	for (let i = startNumber; i <= endNumber; i = (i + interval)) {
		let currentNumber = String(i).padStart(places, '0');
		result.push({ key: currentNumber, value: currentNumber, text: currentNumber });
	}
	return result;
}

export const getS3Data = (docPath, bucket) => {
	let data = { docPath, bucket };
	return encrypt(JSON.stringify(data));
}

export const downloadS3Document = (docPath, bucket) => {
	// Download the file now
	let url = process.env.REACT_APP_MEETING_API_URL + '/v1/s3/download?data=' + getS3Data(docPath, bucket);
	const a = document.createElement('a');
	a.href = url;
	a.target = "_blank";
	a.download = docPath ? docPath.split('/').pop() : '';
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}

export const getAgendaEndTime = (StartDate, hours, minutes) => moment(StartDate).add(hours, 'hours').add(minutes, 'minutes').format('hh:mm A');

export const getEndDateTime = (StartDate, hours, minutes) => moment(StartDate).add(hours, 'hours').add(minutes, 'minutes').format('YYYY-MM-DD');

export const downloadFileByBase64 = (fileContent, fileName) => {
	let a = window.document.createElement('a');
	a.href = 'data:application/octet-stream;base64,' + fileContent;
	a.download = fileName || '';
	// Append anchor to body.
	document.body.appendChild(a);
	a.click();
	// Remove anchor from body
	document.body.removeChild(a);
}

export const validateAlphaNumeric = (value) => {
	let format = /^[a-zA-Z0-9\s\\,]*$/
	return format.test(value);
}

export const getMemberAccountNo = () => {
	if (!_.isEmpty(getCookie(cookieKeysEnum._MyASTM))) {
		return getCookie(cookieKeysEnum._MyASTM)
	}
	return false
}

export const checkIsUserCOARep = userType => {
	let isCOAType = false
	const { id: getStaticCOARepID } = membershipTypeJSON.CooperativeAgreementRep
	if (getStaticCOARepID === userType) {
		isCOAType = true
	}
	return isCOAType
}

export const memberNameFormat = (firstname, middlename, lastname, formatType = '') => {
	lastname = lastname ? lastname.trim() : "";
	firstname = firstname ? firstname.trim() : "";
	middlename = middlename ? middlename.trim().substr(0, 1) : "";
	switch (formatType) {
		case nameFormatTypeEnum.FL:
			return `${firstname} ${lastname}`;
		case nameFormatTypeEnum.LF:
			return `${lastname}, ${firstname}`;
		case nameFormatTypeEnum.LFM:
			return `${lastname}, ${firstname} ${middlename}`;
		case nameFormatTypeEnum.FML:
			return `${firstname} ${middlename} ${lastname}`
		default:
			return `${lastname}, ${firstname} ${middlename}`
	}
};

export const removeAppCookies = (isBeforeLogin = true) => {
	for (let key in cookieKeysEnum) {
		if (isBeforeLogin && (key == "REDIRECT-URL")) {
			continue;
		} else {
			removeCookie(cookieKeysEnum[key]);
		}
	}
}

export const validateRequiredText = (value) => {
	let format = /^[a-zA-Z0-9\d, ]*$/;
	return format.test(value);
}

export const getUUIDNumberFromLocalStorage = url => {
	const getUUIDObject = JSON.parse(window.localStorage.getItem('storeUUIDForAllApiCall'));
	let UuidInEntriesForm = Object.entries(getUUIDObject)
	for (let [key, value] of UuidInEntriesForm) {
		if (key === url) {
			return value;
		}
	}
}

export const checkIdentityDelegation = () => {
    return cacheManager.getItem(USER_INFO) ? get(JSON.parse(cacheManager.getItem(USER_INFO)), IDENTITY_DELEGATION_FLAG) : null;
}

export const getUserInfo = () => {
    if (cacheManager.getItem('user-info')) {
        return JSON.parse(cacheManager.getItem('user-info'));
    }
    return null;
}

export const memberNickFormat = (nickname, firstname) => {
    nickname = nickname ? nickname.trim() : "";
    firstname = firstname ? firstname.trim() : "";
    if (!isEmpty(nickname)) {
        return nickname;
    }
    if (!isEmpty(firstname)) {
        return firstname.length > 15 ? firstname.substr(0, 15) + '...' : firstname;
    }
    return '';
};

export const isJSONString = (value) => {
	if(!value) return false;
    try {
      JSON.parse(value);
      return JSON.parse(value);
    } catch (e) {
      return false;
    }
};

export const updateWCMSLocalStorage = (key, value) => {
	let existingData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.WCMS_HEADER_FOOTER)) || {};
	existingData[key] = value;
	localStorage.setItem(LOCAL_STORAGE_KEYS.WCMS_HEADER_FOOTER, JSON.stringify(existingData));
}

export const openPrintRenewInvoice = () => {
	window.open(`${process.env.REACT_APP_MEETINGAPP_URL}${PRINT_RENEWAL_INVOICE_URL}`, "_blank", "", true);
}

export const printRenewalInvoiceMenu = (position) => {
    const menuItem = {
        parent: MENU_TITLES.MEMBERSHIP,
        id: PRINT_RENEWAL_INVOICE_MENU.ID,
        title: MENU_TITLES.PRINT_RENEWAL_INVOICE,
        handleClick: openPrintRenewInvoice,
        indexAt: [position ? position : PRINT_RENEWAL_INVOICE_MENU.POSITION, CUSTOM_MENU_SPLICE_START_POSITION]
    }
    return menuItem;
}

export const headerSearch = (searchText) => {
  window.location.href = process.env.REACT_APP_WCMS_CATALOG_SEARCH + searchText;
};

export default {
	validateOnlyPositiveNumericInput,
	encrypt,
	decrypt,
	cacheManager,
	hasOpenAuthToken,
	getBreadcrum,
	getHeader,
	formatCommitteList,
	formatMainCommitteList,
	formatSubCommitteList,
	getMessage,
	getAllPageURLs,
	redirectToPage,
	encodeText,
	decodeText,
	logout,
	getTimeArray,
	formatTimeList,
	getStandardTime,
	getCurrentDate,
	getDateWithFormat,
	getMaxEndDate,
	convertToBoolean,
	getUserAgent,
	generateUUID,
	getCalendarMinDate,
	getExcludedDate,
	getNumberArray,
	downloadS3Document,
	getS3Data,
	formatSubSectionCommitteList,
	getAgendaEndTime,
	getEndDateTime,
	downloadFileByBase64,
	validateAlphaNumeric,
	getMemberAccountNo,
	checkIsUserCOARep,
	memberNameFormat,
	getFormattedDate,
	removeAppCookies,
	validateRequiredText,
	getUUIDNumberFromLocalStorage,
    checkIdentityDelegation,
	memberNickFormat,
	isJSONString,
	updateWCMSLocalStorage,
	openPrintRenewInvoice,
	printRenewalInvoiceMenu,
	headerSearch
}
